import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { FileExtension } from '../../../shared/constants/file-extension';
import { IScanReportResponse } from '../../../shared/interfaces/async-report.interface';
import { ICurrentSelectedProperty } from './user.service';
import { UserPropertyService } from './user-property.service';
import { RestService } from './rest.service';
import { AccessibilityAuditToolNames } from '../../../shared/constants/audit-tool';

@Injectable({
  providedIn: 'root',
})
export class EmulatorScanReportService {
  constructor(
    private userService: UserPropertyService,
    private restService: RestService,
  ) {}

  public getFullScanReport(scanId: string, fileExtension: FileExtension, scanUrl: string = ''): Observable<IScanReportResponse> {
    return this.userService
      .currentSelectedProperty()
      .pipe(
        switchMap(({ digitalPropertyId, workspaceId }: ICurrentSelectedProperty) =>
          this.restService.downloadFullScanReport(
            workspaceId,
            digitalPropertyId,
            scanId,
            fileExtension,
            scanUrl,
            AccessibilityAuditToolNames.access_engine,
          ),
        ),
      );
  }

  public generateFullScanReport(
    scanId: string,
    fileExtension: FileExtension,
    scanUrl: string = '',
  ): Observable<IScanReportResponse> {
    return this.userService
      .currentSelectedProperty()
      .pipe(
        switchMap(({ digitalPropertyId, workspaceId }: ICurrentSelectedProperty) =>
          this.restService.generateFullScanReport(
            workspaceId,
            digitalPropertyId,
            scanId,
            fileExtension,
            scanUrl,
            AccessibilityAuditToolNames.access_engine,
          ),
        ),
      );
  }

  public sendScanReportToEmails(scanId: string, emails: string[]): Observable<string[]> {
    return this.userService
      .currentSelectedProperty()
      .pipe(
        switchMap(({ digitalPropertyId, workspaceId }: ICurrentSelectedProperty) =>
          this.restService.sendReportToEmails(
            workspaceId,
            digitalPropertyId,
            scanId,
            AccessibilityAuditToolNames.access_engine,
            emails,
          ),
        ),
      );
  }
}
